export default __webpack_public_path__ + "static/media/paperclip_white.829b5f0e.svg";